module.exports = __webpack_public_path__ + "img/InstrumentAlarm.873c9eb8.svg";